<template>
  <div class="product-order-policy-container">
    <div class="order-policy-header">
      <div v-if="title" class="order-policy-title">{{ title || 'Order Policy' }}</div>
      <div class="order-policy-actions-wrapper">
        <div
          class="order-policy-actions"
          :class="{ 'order-policy-actions-disabled': !sections.length }"
          @click="sections.length && handleCopySections()"
        >
          <v-icon color="primary" size="16">mdi-content-copy</v-icon>
          <span>Copy Sections</span>
        </div>
        <div class="order-policy-actions" @click="handlePasteSections">
          <v-icon color="primary" size="16">mdi-content-paste</v-icon>
          <span>Paste Sections</span>
        </div>
        <div
          v-if="behaviorCreateDescription.showSwitchCreateDescription"
          class="order-policy-actions"
          @click="handleSwitchCreateDescription"
        >
          <v-icon color="primary" size="20">mdi-swap-horizontal</v-icon>
          <span>{{ behaviorCreateDescription.nameActionSwitch }}</span>
        </div>
      </div>
    </div>
    <div class="mb-5" v-if="behaviorCreateDescription.showCkEditor">
      <ckeditor :editor="editor" v-model="catalog[model]" :config="editorConfig" />
    </div>
    <!-- placeholder-add-new -->
    <div
      class="placeholder-add-new"
      @click="handleInsertNewSection()"
      v-if="behaviorCreateDescription.showPlaceholderAddNewSection"
    >
      <div class="placeholder-add-new-item">
        <v-icon color="primary" size="20">mdi-plus</v-icon>
        <span>Add Section</span>
      </div>
    </div>
    <!-- section-item -->
    <div ref="orderPolicyContainer">
      <div v-if="behaviorCreateDescription.showSectionItem" class="">
        <div
          class="product-section-item"
          v-for="(section, index) in visibleSections"
          :key="section.id"
          :id="section.id"
        >
          <div class="section-item-actions">
            <div class="action-item" @click="handleViewSection(section)">
              <v-icon color="primary" size="19">mdi-expand-all</v-icon>
              <span>Expand</span>
            </div>
            <div class="action-item" @click="handleViewSectionEditor(section)">
              <v-icon color="primary" size="19">mdi-pencil</v-icon>
              <span>Edit</span>
            </div>
            <div class="action-item" @click="handleDeleteSection(section)">
              <v-icon color="error" size="20">mdi-delete</v-icon>
              <span>Delete</span>
            </div>
          </div>
          <div class="move-action">
            <div
              :class="index === 0 ? 'move-action-item-disabled' : 'move-action-item'"
              @click="handleMoveSection(section, 'up')"
            >
              <v-icon color="primary" size="20">mdi-arrow-up</v-icon>
            </div>
            <div
              :class="index === visibleSections.length - 1 ? 'move-action-item-disabled' : 'move-action-item'"
              @click="handleMoveSection(section, 'down')"
            >
              <v-icon color="primary" size="20">mdi-arrow-down</v-icon>
            </div>
          </div>
          <div class="insert-new-section-action">
            <div class="insert-new-section-action-item" @click="handleInsertNewSection(section, 'above')">
              <v-icon color="primary" size="20">mdi-plus</v-icon>
              <span>Add Section Above</span>
            </div>
            <div class="insert-new-section-action-item" @click="handleInsertNewSection(section, 'below')">
              <v-icon color="primary" size="20">mdi-plus</v-icon>
              <span>Add Section Below</span>
            </div>
          </div>
          <div v-html="section.html"></div>
        </div>
      </div>
    </div>

    <!-- Template Modal -->
    <SelectSectionTemplate
      :open="showSectionTemplateModal"
      :orderpolicy="true"
      @select="handleSectionTemplateSelect"
      @close="handleCloseSectionTemplateModal"
    />
    <!-- View Section Modal -->
    <v-dialog v-model="viewExpandSection.showViewSection" fullscreen hide-overlay>
      <ViewSectionTemplate
        v-if="viewExpandSection.showViewSection"
        :open="viewExpandSection.showViewSection"
        :orderpolicy="true"
        :section="viewExpandSection.section"
        @close="handleCloseViewSection"
      />
    </v-dialog>

    <!-- Safe Checkout Section Editor -->
    <SafeCheckoutSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGuaranteedSafeCheckout"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <!-- Safe Checkout 02 Section Editor -->
    <SafeCheckout02SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGuaranteedSafeCheckout02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <!-- Order Info Section Editor -->
    <OrderInfoSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionOrderInfo"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <PolicyAccordionBasicSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionPolicyAccordionBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <PolicyYuriAccordionSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionPolicyYuriAccordion"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <PolicyYuriListSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionPolicyYuriList"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <PolicyYuriVideosSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionPolicyYuriVideos"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <PolicyYuriReivewSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionPolicyYuriReivew"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <!-- Freestyle Order Policy Section Editor -->
    <FreestyleOrderPolicySectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFreestyleOrderPolicy"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <!-- Trust Badge Section Editor -->
    <TrustBadgeSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTrustBadge"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <!-- Saintbrand Shipping Section Editor -->
    <SaintbrandShippingSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSaintbrandShipping"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <LeonieandcoReviewGrid
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionLeonieandcoReviewGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <!-- Cedrow Benefits Policy Section Editor -->
    <CardCedrowBenefitsPolicySectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCedrowBenefitsPolicy"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <EskiinPolicySectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionEskiinPolicy"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
  </div>
</template>
<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { cloneDeepObject } from './common/utils';
import { sectionType } from './common/types';
import SelectSectionTemplate from './modal-sections/select-section-template.vue';
import ViewSectionTemplate from './modal-sections/view-section.vue';
import SafeCheckoutSectionEditor from './section-editor/safe-checkout.vue';
import OrderInfoSectionEditor from './section-editor/order-info.vue';
import PolicyAccordionBasicSectionEditor from './section-editor/policy-accordion-basic.vue';
import PolicyYuriAccordionSectionEditor from './section-editor/policy-yuri-accordion.vue';
import PolicyYuriListSectionEditor from './section-editor/policy-yuri-list.vue';
import PolicyYuriVideosSectionEditor from './section-editor/policy-yuri-videos.vue';
import PolicyYuriReivewSectionEditor from './section-editor/policy-yuri-reivew.vue';
import SafeCheckout02SectionEditor from './section-editor/safe-checkout-02.vue';
import FreestyleOrderPolicySectionEditor from './section-editor/freestyle-order-policy.vue';
import TrustBadgeSectionEditor from './section-editor/trust-badge.vue';
import SaintbrandShippingSectionEditor from './section-editor/saintbrand-shipping.vue';
import EskiinPolicySectionEditor from './section-editor/eskiin-policy.vue';
import { extractDataAttributesFromHTML } from './common/html/extract';
import { descriptionjs } from './main';
import {
  deleteSection,
  insertSections,
  loadSectionsFromHtml,
  regenerateSectionIds,
  resolveSectionInsertIndex,
} from './common/insert-section.js';
import LeonieandcoReviewGrid from './section-editor/leonieandco-review-grid.vue';
import CardCedrowBenefitsPolicySectionEditor from './section-editor/card-cedrow-benefits-policy.vue';

export default {
  name: 'OrderPolicy',
  components: {
    SelectSectionTemplate,
    ViewSectionTemplate,
    SafeCheckoutSectionEditor,
    OrderInfoSectionEditor,
    PolicyAccordionBasicSectionEditor,
    PolicyYuriAccordionSectionEditor,
    PolicyYuriListSectionEditor,
    PolicyYuriVideosSectionEditor,
    PolicyYuriReivewSectionEditor,
    SafeCheckout02SectionEditor,
    FreestyleOrderPolicySectionEditor,
    TrustBadgeSectionEditor,
    SaintbrandShippingSectionEditor,
    LeonieandcoReviewGrid,
    CardCedrowBenefitsPolicySectionEditor,
    EskiinPolicySectionEditor,
  },
  props: {
    model: {
      type: String,
      default: 'orderPolicy',
    },
    catalog: {
      type: Object,
      required: true,
    },
    catalogCreation: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      createDescriptionBy: 'template',
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      indexInsertNewSection: -1,
      sectionType,
      sections: [],
      showSectionTemplateModal: false,
      viewExpandSection: {
        orderpolicy: false,
        showViewSection: false,
        section: {},
      },
      viewSectionEditor: {
        show: false,
        sectionExtract: {},
        section: {},
      },
    };
  },
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const elementPosition = element.offsetTop + 132;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
        element.classList.add('active-section');
        setTimeout(() => {
          element.classList.remove('active-section');
        }, 3000);
      }
    },
    handleViewSection(section) {
      this.viewExpandSection.orderpolicy = true;
      this.viewExpandSection.showViewSection = true;
      this.viewExpandSection.section = section;

      const uniqueId = Math.random()
        .toString(36)
        .slice(2, 8);
      // anh e sau có maintain thì chú ý cái prefix là prl nhé, nó được set trong lúc chọn template
      const regex = new RegExp(`prl-[a-z0-9]{6}`, 'g');
      this.viewExpandSection.section = {
        ...section,
        html: section.html.replace(regex, uniqueId),
      };
    },
    handleCloseViewSection() {
      this.viewExpandSection.orderpolicy = false;
      this.viewExpandSection.showViewSection = false;
      this.viewExpandSection.section = {};
    },
    handleViewSectionEditor(section) {
      switch (section.type) {
        case sectionType.sectionGuaranteedSafeCheckout: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGuaranteedSafeCheckout(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionOrderInfo: {
          const sectionExtract = extractDataAttributesFromHTML.sectionOrderInfo(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionPolicyAccordionBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionPolicyAccordionBasic(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionPolicyYuriAccordion: {
          const sectionExtract = extractDataAttributesFromHTML.sectionPolicyYuriAccordion(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionPolicyYuriList: {
          const sectionExtract = extractDataAttributesFromHTML.sectionPolicyYuriList(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionPolicyYuriVideos: {
          const sectionExtract = extractDataAttributesFromHTML.sectionPolicyYuriVideos(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionPolicyYuriReivew: {
          const sectionExtract = extractDataAttributesFromHTML.sectionPolicyYuriReivew(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGuaranteedSafeCheckout02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGuaranteedSafeCheckout02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFreestyleOrderPolicy: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFreestyleOrderPolicy(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSaintbrandShipping: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSaintbrandShipping(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTrustBadge: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTrustBadge(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionLeonieandcoReviewGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionLeonieandcoReviewGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCedrowBenefitsPolicy: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCedrowBenefitsPolicy(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionEskiinPolicy: {
          const sectionExtract = extractDataAttributesFromHTML.sectionEskiinPolicy(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        default:
          break;
      }
    },
    handleCloseSectionEditor() {
      this.viewSectionEditor = {
        show: false,
        sectionExtract: {},
        section: {},
      };
    },
    handleUpdateSection(section) {
      this.sections = this.sections.map(item => (item.id === section.id ? section : item));
    },
    handleDeleteSection(section) {
      this.sections = deleteSection(this.sections, section);
    },
    handleInsertAllSections(templates) {
      this.sections = insertSections(this.sections, templates);
      this.showSectionTemplateModal = false;
    },
    handleRemoveAllSections() {
      if (window.confirm('Are you sure to remove all order policy sections?')) {
        this.sections = [];
      }
    },
    async handleCopySections() {
      const html = (this.sections || []).map(section => section.html).join('');
      if (!html) {
        this.$store.commit('setMessages', { messages: 'No sections to copy', type: 'warning' });
        return;
      }

      try {
        await navigator.clipboard.writeText(html);
        this.$store.commit('setMessages', { messages: 'Sections copied to clipboard', type: 'success' });
      } catch (err) {
        console.error('Failed to copy sections: ', err);
        this.$store.commit('setMessages', { messages: 'Failed to copy sections', type: 'error' });
      }
    },
    async handlePasteSections() {
      let clipboardText = '';
      try {
        clipboardText = await navigator.clipboard.readText();
      } catch (err) {
        console.error('Failed to read clipboard: ', err);
        this.$store.commit('setMessages', {
          messages: 'Unable to read clipboard. Please allow clipboard permission and try again.',
          type: 'error',
        });
        return;
      }

      if (!clipboardText?.trim()) {
        this.$store.commit('setMessages', { messages: 'Clipboard is empty', type: 'warning' });
        return;
      }

      const parsedSections = regenerateSectionIds(loadSectionsFromHtml(clipboardText));
      if (!parsedSections.length) {
        this.$store.commit('setMessages', { messages: 'No valid sections found in clipboard', type: 'warning' });
        return;
      }

      this.sections = insertSections(this.sections, parsedSections);
      this.$store.commit('setMessages', { messages: 'Sections pasted', type: 'success' });
    },
    handleCloseSectionTemplateModal() {
      this.showSectionTemplateModal = false;
      this.indexInsertNewSection = -1;
    },
    handleShowPopupSelectSectionTemplate() {
      this.showSectionTemplateModal = true;
    },
    handleSectionTemplateSelect(template) {
      const atIndex = this.indexInsertNewSection >= 0 ? this.indexInsertNewSection : undefined;
      this.sections = insertSections(this.sections, template, { atIndex });
      this.showSectionTemplateModal = false;
      this.indexInsertNewSection = -1;
      setTimeout(() => {
        this.scrollToSection(template.id);
      }, 100);
    },
    handleMoveSection(section, direction) {
      const index = this.sections.findIndex(item => item.id === section.id);
      if (index === -1) return;
      const newSections = cloneDeepObject(this.sections);
      if (direction === 'up') {
        if (index === 0) return;
        newSections.splice(index, 1);
        newSections.splice(index - 1, 0, section);
      } else if (direction === 'down') {
        if (index === newSections.length - 1) return;
        newSections.splice(index, 1);
        newSections.splice(index + 1, 0, section);
      } else {
        return;
      }
      this.sections = newSections.map((item, index) => ({ ...item, position: index }));
      setTimeout(() => {
        this.scrollToSection(section.id);
      }, 100);
    },
    handleInsertNewSection(section, position) {
      const insertIndex = resolveSectionInsertIndex(this.sections, { section, position });
      if (insertIndex < 0) return;
      this.indexInsertNewSection = insertIndex;
      this.handleShowPopupSelectSectionTemplate();
    },
    handleSwitchCreateDescription() {
      this.createDescriptionBy = this.createDescriptionBy === 'editor' ? 'template' : 'editor';
      this.catalog[this.model] = '';
      this.sections = [];
    },
  },
  computed: {
    behaviorCreateDescription() {
      const objState = {};
      if (this.catalogCreation) {
        objState.nameActionSwitch = this.createDescriptionBy === 'editor' ? 'Use template' : 'Use editor';
        objState.showCkEditor = this.createDescriptionBy === 'editor';
        objState.showSwitchCreateDescription = true;
        objState.showPlaceholderAddNewSection =
          this.visibleSections.length === 0 && this.createDescriptionBy === 'template';
        objState.showSectionItem = this.createDescriptionBy === 'template';
      } else {
        objState.nameActionSwitch = '';
        objState.showCkEditor = false;
        objState.showSwitchCreateDescription = false;
        objState.showPlaceholderAddNewSection = this.visibleSections.length === 0;
        objState.showSectionItem = true;
      }

      return objState;
    },
    visibleSections() {
      return (this.sections || []).filter(s => !s?.hidden);
    },
  },
  mounted() {
    this.sections = loadSectionsFromHtml(this.catalog[this.model]);
    this.$root.$on('insert-all-policy-sections', this.handleInsertAllSections);
    this.$root.$on('remove-all-policy-sections', this.handleRemoveAllSections);
  },
  beforeDestroy() {
    this.$root.$off('insert-all-policy-sections', this.handleInsertAllSections);
    this.$root.$off('remove-all-policy-sections', this.handleRemoveAllSections);
  },
  watch: {
    catalog: {
      handler(newVal) {
        this.sections = loadSectionsFromHtml(newVal[this.model]);
      },
    },
    sections: {
      handler(newVal) {
        this.$emit(
          'update:sectionsPanel',
          (newVal || [])
            .filter(s => !s?.hidden)
            .map(section => ({
              title: section.title,
              id: section.id,
            })),
        );
        this.$emit('update:bodyHtmlOrderPolicy', newVal.map(section => section.html).join(''));

        this.$nextTick(() => {
          const container = this.$refs.orderPolicyContainer;
          if (!container) return;

          const scriptsSwiper = container.querySelector('script[data-attribute="script-swiper"]');

          if (scriptsSwiper) {
            const newScriptCDN = document.createElement('script');
            newScriptCDN.src = scriptsSwiper.getAttribute('src');
            newScriptCDN.setAttribute('data-ignore', 'true');

            newScriptCDN.onload = () => {
              runOtherScripts();
            };

            scriptsSwiper.parentNode.replaceChild(newScriptCDN, scriptsSwiper);
          } else {
            runOtherScripts();
          }

          function runOtherScripts() {
            const scripts = container.querySelectorAll('script:not([data-executed]):not([data-ignore])');
            scripts.forEach(script => {
              const newScript = document.createElement('script');
              for (const attr of script.attributes) newScript.setAttribute(attr.name, attr.value);
              newScript.text = script.textContent;
              // newScript.setAttribute('type', 'module')
              script.parentNode.replaceChild(newScript, script);
              newScript.setAttribute('data-executed', '1');
            });
          }
          descriptionjs();
        });
      },
    },
  },
};
</script>
